import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import {findUsersByQueryString} from "../../utils/requestUtils";

const apiUrl = Config.apiUrl;
const UserList = () => {
    let [users, setUsers] = useState([]);
    const [showPendingQrOnly, setShowPendingQrOnly] = useState(false);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    async function makeQuery(query) {
        try {
            setLoading(true);
            const response = await findUsersByQueryString(query);
            setUsers(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        makeQuery('');
    }, []); // Empty dependency array ensures that useEffect runs only once, similar to componentDidMount

    async function excluirUsuario(id) {
        try {
            const url = apiUrl + '/api/users/' + id;
            await makeRequest(url, 'DELETE', {'Useruuid':Cookies.get('userUUID')});
            await makeQuery(queryString);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleInputChange = (e) => {
        const string = e.target.value;
        if (string.length >= 3 || string.length === 0) {
            makeQuery(string);
        }
        setQueryString(string);
    };

    const getUserTypeLabel = (userType) => {
        switch(userType) {
            case 0: return 'Básico';
            case 1: return 'Intermediário';
            case 2: return 'Admin';
            default: return 'Básico';
        }
    };

    const displayUsers = showPendingQrOnly
        ? users.filter((u) => u.qrInviteNeverLoggedIn === true)
        : users;

    const qrInviteColumnLabel = (user) => {
        if (user.qrInviteNeverLoggedIn === true) {
            return 'Pendente';
        }
        const em = user.email || '';
        if (em.startsWith('qr.') && em.endsWith('@invite.local')) {
            return '—';
        }
        return '';
    };

    return (
        <>
            <div className="header-label">Consulta de Usuários</div>

            <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', flexWrap: 'wrap', gap: 8}}>
                <input ref={inputQueryString} type="text" value={queryString} onChange={handleInputChange}/>
                <label style={{display: 'flex', alignItems: 'center', gap: 6, fontSize: 14, whiteSpace: 'nowrap'}}>
                    <input
                        type="checkbox"
                        checked={showPendingQrOnly}
                        onChange={(e) => setShowPendingQrOnly(e.target.checked)}
                    />
                    Só convite QR sem login
                </label>
                <button onClick={() => navigate('/user')}>Novo</button>
            </div>

            <table style={{width: '680px'}}>

                <tr>
                    <th>
                        Código
                    </th>
                    <th>
                        Nome
                    </th>
                    <th>
                        Email
                    </th>
                    <th>
                        Tipo
                    </th>
                    <th>
                        Convite QR
                    </th>
                    <th/>
                    <th/>
                    <th/>
                </tr>
                <tbody style={{overflowY: 'auto'}}>

                {displayUsers.map((user) => (


                    <tr key={user.id}>
                        <td>
                            <div>{user.id}</div>
                        </td>
                        <td>
                            <div>{user.name}</div>
                        </td>
                        <td>
                            <div>{user.email}</div>
                        </td>
                        <td>
                            <div>{getUserTypeLabel(user.userType)}</div>
                        </td>
                        <td>
                            <div title={user.qrInviteNeverLoggedIn ? 'Criado por QR; aguardando primeiro acesso' : ''}>
                                {qrInviteColumnLabel(user)}
                            </div>
                        </td>
                        <td>
                            <button onClick={async () => {
                                await navigate('/user?id='+user.id);
                            }}>Editar
                            </button>
                        </td>
                        <td>
                            <button className="remove-button" onClick={async () => {
                                // eslint-disable-next-line no-restricted-globals
                                if (window.confirm('Deseja realmente excluir?')) {
                                    await excluirUsuario(user.id);
                                }
                            }}>Excluir
                            </button>
                        </td>

                    </tr>
                ))}
                </tbody>
                {displayUsers.length === 0 && (<tfoot>Nenhum item encontrado.</tfoot>)}
            </table>


        </>
    );
};

export default UserList;



